export default __webpack_public_path__ + "static/media/celestialart_hd.e735a14e.webp";